import React, { useEffect, createContext } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom/dist";
import { urlDataLocalBase64 } from "../../../general/functions/base64Function";
import InitWebSocket from "../../../general/components/websocket/InitWebSocket";

// export const UserTypeContext = createContext();
export default function AuthValidasi() {
  const store = useSelector((state) => state.authmodul_user_data);
  const dataUrlLocal = urlDataLocalBase64();
  console.log("decodeBase64", dataUrlLocal);
  useEffect(() => {
    if (store.success) {
      console.log("Validasi lokasi", store.data);
    }
  }, [store]);

  return (
    <div>
      {store.data.token != null && typeof store.data.token == "string" ? (
        <>
          <InitWebSocket />
          <Outlet />
        </>
      ) : (
        <Navigate to={"/session?data=" + dataUrlLocal} />
      )}
    </div>
  );
}
